export const appDeleteUserIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9.5" fill="white" stroke="#D78987"/><path d="M12 8L8 12" stroke="#D78987" stroke-linecap="square" stroke-linejoin="round"/><path d="M8 8L12 12" stroke="#D78987" stroke-linecap="square" stroke-linejoin="round"/></svg>`,
    name: 'delete-user'
};